"use client";
import * as React from "react";
const SvgNotificationsFilled = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 13 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M6.5 16c.9 0 1.63-.74 1.63-1.64H4.87c0 .9.73 1.64 1.63 1.64m4.88-4.92v-4.1c0-2.53-1.34-4.63-3.66-5.2v-.55C7.72.55 7.17 0 6.5 0S5.28.55 5.28 1.23v.56c-2.33.56-3.66 2.66-3.66 5.18v4.1L0 12.73v.82h13v-.82z" }));
export {
  SvgNotificationsFilled as default
};
